import { LOGIN_USER, SELECT_BRANCH, SELECT_CASHREGISTER, SELECT_POINTSALE, CLEAR_USER, TOGGLE_THEME } from './actions';

const initialState = {
    lightTheme: true,
    configuration: {
        user: {
            roles: [],
            businesses: [],
            name: '',
            fullName: '',
            email: ''
        },    
        branch: { id: 0, name: '', code: null },
        pv: { id: 0, name: '' },
        cashRegister: { id: 0, name: '' },
        business: { id: 0, paymentMethods: [] }
    }
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case LOGIN_USER:
            return {
                ...state,
                configuration: {
                    ...state.configuration,
                    user: action.user
                }
            }
        case SELECT_BRANCH:
            return {
                ...state,
                configuration: {
                    ...state.configuration,
                    business: action.business,
                    branch: action.branch,
                    pv: action.pv,
                    cashRegister: action.cashRegister
                }
            }
        case SELECT_CASHREGISTER:
            return {
                ...state,
                configuration: {
                    ...state.configuration,
                    cashRegister: action.cashRegister
                }
            }
        case SELECT_POINTSALE:
            return {
                ...state,
                configuration: {
                    ...state.configuration,
                    pv: action.pv
                }
            }
        case TOGGLE_THEME:
            return {
                ...state,
                lightTheme: action.isLight
            }
        case CLEAR_USER:
            return initialState;
        default:
            return state;
    }
}